var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc3Years(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_17280)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5433 8.46446C8.50257 12.9832 4.81871 23.8114 9.22087 32.6188C13.623 41.4263 24.4949 44.9791 33.5356 40.4604C41.0295 36.7147 44.85 28.6217 43.4199 20.9486C43.2325 19.9431 43.8956 18.9761 44.9011 18.7888C45.9065 18.6014 46.8735 19.2645 47.0609 20.2699C48.793 29.5632 44.1674 39.2869 35.1915 43.7733C24.3775 49.1784 11.2526 44.9678 5.90795 34.2747C0.563294 23.5816 5.07348 10.5566 15.8874 5.15153C24.9057 0.643998 35.5171 2.82223 41.901 9.86462C42.5879 10.6224 42.5305 11.7935 41.7727 12.4804C41.015 13.1673 39.8438 13.1098 39.1569 12.3521C33.8864 6.53797 25.0728 4.70103 17.5433 8.46446Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7256 24.5124C29.7256 23.9601 30.1733 23.5124 30.7256 23.5124H32.5363V21.7932C32.5363 21.2409 32.984 20.7932 33.5363 20.7932H33.7553C34.3076 20.7932 34.7553 21.2409 34.7553 21.7932V23.5124H36.492C37.0443 23.5124 37.492 23.9601 37.492 24.5124V24.7172C37.492 25.2695 37.0443 25.7172 36.492 25.7172H34.7553V27.4364C34.7553 27.9887 34.3076 28.4364 33.7553 28.4364H33.5363C32.984 28.4364 32.5363 27.9887 32.5363 27.4364V25.7172H30.7256C30.1733 25.7172 29.7256 25.2695 29.7256 24.7172V24.5124Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5882 22.8481H21.48C22.8813 22.8481 23.1361 22.1519 23.1361 20.8228C23.1361 19.1772 22.8176 18.6076 22.0533 18.6076C21.3526 18.6076 21.0341 19.1772 21.0341 20.5063V21.2658H17.2121C17.2121 17.2785 18.4224 15 22.3081 15C25.3019 15 27.1492 16.8354 27.1492 20.443C27.1492 22.8481 26.4485 23.9241 25.3019 24.3671C26.6396 25.1266 27.4677 25.9494 27.4677 28.8608C27.4677 32.6582 26.0663 35 22.117 35C17.4669 35 16.8936 31.8987 16.9573 27.7848H20.9067V29.557C20.9067 30.6329 21.3526 31.0759 21.9259 31.0759C22.754 31.0759 23.1998 30.5063 23.1998 28.7342C23.1998 26.7722 22.8176 26.076 21.3526 26.076H20.5882V22.8481Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_17280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc3Years);
export default __webpack_public_path__ + "static/media/ic_3years.308da7c0f39a2fc1d324b3bf348a8c8f.svg";
export { ForwardRef as ReactComponent };